import type { ReactNode } from 'react';

interface SliderProps {
  id: string;
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  /** Gia tri da dinh dang de hien canh nhan. Bo trong thi hien nguyen so. */
  display?: string;
  /** Nhan hai dau thanh truot — de nguoi dung biet dang keo trong khoang nao. */
  minLabel?: string;
  maxLabel?: string;
  /** Dong giai thich duoi thanh truot: tac dong uoc tinh, hoac ly do dang bi khoa. */
  hint?: ReactNode;
}

/**
 * Thanh truot co nhan va o hien gia tri.
 *
 * Gia tri LUON hien thanh chu ben canh nhan: mot thanh truot khong co so doc kem thi
 * nguoi van hanh khong bao gio biet minh vua dat nguong 0,90 hay 0,91 — ma o day mot
 * phan tram khac biet la thay doi that ve hanh vi cua dich vu.
 */
export function Slider({
  id,
  label,
  value,
  min,
  max,
  step,
  onChange,
  disabled = false,
  display,
  minLabel,
  maxLabel,
  hint,
}: SliderProps) {
  return (
    <div className={disabled ? 'opacity-60' : ''}>
      <div className="flex items-baseline justify-between gap-2">
        <label className="cf-label mb-0" htmlFor={id}>
          {label}
        </label>
        <span className="cf-mono text-sm font-semibold text-slate-900 dark:text-slate-100">
          {display ?? String(value)}
        </span>
      </div>

      <input
        id={id}
        type="range"
        className="mt-2 w-full accent-sky-600 disabled:cursor-not-allowed dark:accent-sky-500"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(event) => {
          const parsed = Number(event.target.value);
          // Trinh duyet chi tra chuoi. Gia tri la thi bo qua han thay vi day NaN vao state
          // roi de no chay thang xuong body cua PATCH.
          if (Number.isFinite(parsed)) onChange(parsed);
        }}
      />

      {(minLabel !== undefined || maxLabel !== undefined) && (
        <div className="flex justify-between text-[11px] text-slate-500 dark:text-slate-400">
          <span>{minLabel ?? ''}</span>
          <span>{maxLabel ?? ''}</span>
        </div>
      )}

      {hint !== undefined && (
        <div className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">{hint}</div>
      )}
    </div>
  );
}
